import { QueryClient } from "@tanstack/react-query";

/**
 * Central React Query client.
 *
 * Defaults tuned for an admin panel (data grids, dashboards):
 * - staleTime 1min: avoid refetch storms when components remount during navigation.
 * - gcTime 5min: keep recently used data cached so back-navigation is instant.
 * - retry 1: one retry smooths transient blips without hammering a failing API.
 * - refetchOnWindowFocus off: admins tab away constantly; focus refetch is noise here.
 *
 * Error REPORTING is intentionally NOT wired here — the Axios interceptors
 * (src/services/api.tsx, api-agent.tsx) already toast and report 5xx/network
 * errors to Sentry. Adding a QueryCache onError would double-report.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60,
            gcTime: 1000 * 60 * 5,
            retry: 1,
            refetchOnWindowFocus: false,
        },
        mutations: {
            retry: 0,
        },
    },
});
